import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ListarPedidosPosPagoService {

  constructor( private readonly http : HttpClient ) { }

  public getAllEmpresas (idEmpresa) {  
    return this.http.get( `/apiconnect/importation/company/group-company/${idEmpresa}/companies?tipOrdernamento=nomeAsc` ); 
  }

  public getAllPedidos (idEmpresa , url) {  
    return this.http.get( `/apiconnect/orders/order/post/${idEmpresa}/companies`+ url ); 
  }
  
  public postSenha (idPedido , obj) {  
    return this.http.post( `/apiconnect/importation/order/release/${idPedido}/companies`,obj ); 
  }
}
